import React from 'react';
import styled from 'styled-components';
import { useStoreActions, useStoreState } from '../store';
import { Browser } from '../utils/browser';
import { getFullscreenElement } from '../utils/fullscreen';
import theme from '../utils/theme';
import fullScreenExpandIcon from '../assets/images/full-screen-expand.svg';
import fullScreenCollapseIcon from '../assets/images/full-screen-collapse.svg';

interface Props {
  className?: string;
}

export function FullscreenControl(props: Props) {
  const casting = useStoreState(state => state.chromecast.casting);
  const controlsVisible = useStoreState(state => state.player.controlsVisible);
  const actions = useStoreActions(actions => actions);
  const [fullscreenActive, setFullscreenActive] = React.useState(false);

  // Detect fullscreen state change
  React.useEffect(() => {
    const interval = setInterval(() => {
      const active = !!getFullscreenElement();
      if (active !== fullscreenActive) setFullscreenActive(active);
    }, 1000);

    return () => clearInterval(interval);
  }, [fullscreenActive]);

  function fullScreenButtonVisible() {
    if (casting) {
      return false;
    } else if (Browser.isIOS) {
      return false;
    } else {
      return true;
    }
  }

  function handleFullscreenClick() {
    fullscreenActive ? actions.player.disableFullScreen() : actions.player.enableFullScreen();
  }

  return fullScreenButtonVisible() ? (
    <Container
      className={props.className}
      active={!!getFullscreenElement()}
      visible={controlsVisible ?? true}
      onClick={handleFullscreenClick}
    />
  ) : null;
}

const Container = styled.div<{ active: boolean; visible?: boolean }>`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease-out;
  background: url(${p => (p.active ? fullScreenCollapseIcon : fullScreenExpandIcon)}) no-repeat center / contain;

  @media ${theme.mobileMediaQuery} {
    right: 24px;
    bottom: 40px;
    width: 18px;
    height: 18px;
  }
`;
